// src/components/GameOverScreen.jsx
import React from "react";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const MAX_ROUNDS = 3; // keep in sync with App.js

/**
 * GameOverScreen
 * ──────────────────────────────────────────────────────────────────────
 * Props:
 *   - score: final score integer
 *   - allRoundsData: array of objects, each { object, feedbackSlots, score }
 *   - restartGame: function to call when “Play Again” is clicked
 *
 * Shows final score and a grid of guess‐squares for each round.
 */
export default function GameOverScreen({ score, allRoundsData, restartGame }) {
  return (
    <Card className="w-96">
      <CardHeader>
        <CardTitle>Game Over!</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-lg mb-4">
          Your final score: {score} out of {MAX_ROUNDS * 5}
        </p>
        <div style={{ marginBottom: "16px" }}>
          <h4>Guess History:</h4>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              marginBottom: "8px",
            }}
          >
            {allRoundsData.slice(0, MAX_ROUNDS).map((roundData, roundIdx) => (
              <div
                key={roundIdx}
                style={{
                  display: "flex",
                  gap: "4px",
                  padding: "4px",
                  backgroundColor: "#0e1729",
                  borderRadius: "4px",
                  marginBottom: "4px",
                }}
              >
                {roundData.feedbackSlots.map((guessInfo, guessIdx) => {
                  let squareColor = "#334155";
                  if (guessInfo) {
                    if (guessInfo.isCorrect) {
                      squareColor = "#10b981"; // green
                    } else if (guessInfo.percentage >= 80) {
                      squareColor = "#f59e0b"; // orange
                    } else if (guessInfo.percentage >= 50) {
                      squareColor = "#ef4444"; // red
                    } else {
                      squareColor = "#000000"; // black
                    }
                  }
                  return (
                    <div
                      key={guessIdx}
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "4px",
                        backgroundColor: squareColor,
                        border: "1px solid #64748b",
                      }}
                      title={
                        guessInfo
                          ? `Guess ${guessIdx + 1}: ${guessInfo.percentage}%`
                          : ""
                      }
                    />
                  );
                })}
              </div>
            ))}
          </div>
        </div>
        <Button onClick={restartGame}>Play Again</Button>
      </CardContent>
    </Card>
  );
}
